import React, { useRef, useEffect } from 'react';
import { Logger, LoggingContext } from './LoggingContext';
import { getSessionStats } from './utils';

export type LoggingProviderProps = React.PropsWithChildren<{
    logger: Logger;
}>;

const halfDayMilli = 1000 * 60 * 60 * 12;

export const LoggingProvider = ({ children, logger }: LoggingProviderProps) => {
    const initialMountRef = useRef(true);

    // Triggers the sending of session stats after component has mounted
    useEffect(() => {
        if (initialMountRef.current) {
            const statsSent = localStorage.getItem('statsSent');

            const statsSentNum = statsSent ? JSON.parse(statsSent) : 0;

            if (statsSentNum < Date.now() - halfDayMilli) {
                const sessionStats = getSessionStats();
                (async () => {
                    await logger.stats(sessionStats);
                    localStorage.setItem('statsSent', JSON.stringify(Date.now()));
                })();
            }
        }

        initialMountRef.current = false;
    }, [logger]);

    return <LoggingContext.Provider value={logger}>{children}</LoggingContext.Provider>;
};
